/** @jsx jsx */
import { jsx } from '@emotion/core';
import { N300 } from '@atlaskit/theme/colors';
import { gs } from '../utils';
export var Provider = function (_a) {
    var name = _a.name, iconUrl = _a.iconUrl, icon = _a.icon;
    var iconToRender = icon || null;
    if (!iconToRender && iconUrl) {
        iconToRender = (jsx("img", { css: { height: gs(1.5), width: gs(1.5) }, src: iconUrl }));
    }
    return (jsx("div", { css: { display: 'flex', alignItems: 'center' } },
        iconToRender,
        jsx("span", { css: {
                fontSize: gs(1.5),
                color: N300,
                margin: 0,
                marginLeft: gs(0.5),
            } }, name)));
};
//# sourceMappingURL=Provider.js.map